import ethToken from 'assets/icons/tokens/eth.png'
import daiToken from 'assets/icons/tokens/dai.png'
import usdtToken from 'assets/icons/tokens/usdt.png'
import rethToken from 'assets/icons/tokens/reth.png'
import usdcToken from 'assets/icons/tokens/usdc.png'
import wstethToken from 'assets/icons/tokens/wsteth-arbitrum.png'
import usdsToken from 'assets/icons/tokens/usds.png'
import uniToken from 'assets/icons/tokens/uni.png'
import udsceToken from 'assets/icons/tokens/usdc.e.png'
import wbtcToken from 'assets/icons/tokens/wbtc.png'
import wethToken from 'assets/icons/tokens/weth.png'
import lidoToken from 'assets/icons/tokens/lido.png'
import linkToken from 'assets/icons/tokens/link.png'
import mkrToken from 'assets/icons/tokens/mkr.png'
import compToken from 'assets/icons/tokens/comp.png'
import arbToken from 'assets/icons/tokens/arb.png'
import weethToken from 'assets/icons/tokens/weeth.png'
import usdeToken from 'assets/icons/tokens/usde.png'
import cbbtcToken from 'assets/icons/tokens/cbbtc.png'
import { tokenAddresses } from 'configs/config-token-addresses'
import axios from 'axios'

export function getTokens(currency0, currency1) {
  const token0Retrieved = tokenAddresses.find((token) => {
    if(currency0 === "eth") {
      return token.tokenSymbol.toLowerCase() === "weth"
    } else {
      return token.tokenSymbol.toLowerCase() === currency0
    }
  })
  
  const token1Retrieved = tokenAddresses.find((token) => {
    if(currency1 === "eth") {
      return token.tokenSymbol.toLowerCase() === "weth"
    } else {
      return token.tokenSymbol.toLowerCase() === currency1
    }
  })

  return { token0Retrieved, token1Retrieved}
}

export async function getInputOutputTokenAmounts(trade, token0, token1) {
  let input, output, inputUSD, outputUSD

  if((token0.decimals == "18") && (token1.decimals == "18")) {
    input = trade.inputAmount.toExact() * 1000000000000000000 // 1 quintillion
    output = trade.outputAmount.toExact() * 1000000000000000000 // 1 quintillion
  } else {
    input = token0.decimals === "18" ? trade.inputAmount.toFixed() * 1000000000000000000 : trade.inputAmount.toFixed() * 1000000000000000000  
    output = token1.decimals === "18" ? trade.outputAmount.toFixed() * 1000000000000000000 : trade.outputAmount.toFixed() / 1000000    
  }

  return { input, output }
}

export async function getInputOutputTokenAmountsUSD(currency0, currency1, input, output) {
  const usdExchangeRates= await axios({ 
    method: "get", 
    url: `https://min-api.cryptocompare.com/data/price?fsym=${currency0}&tsyms=USD,${currency1}`, 
    responseType: "application/json" 
  })  
  const exchangeRate = JSON.parse(usdExchangeRates.data)  
  const inputUSD = Number(input * exchangeRate['USD'])
  const secondTokenExchangeRate = exchangeRate[currency1.toUpperCase()]
  let outputUSD

  switch(currency1) {
    case "eth":
      outputUSD = Number(output / secondTokenExchangeRate)
      break
    case "dai":
      outputUSD = Number(input * secondTokenExchangeRate)
      break
    case "usdt":
      outputUSD = Number(input * secondTokenExchangeRate)
      break
    case "weth":
      outputUSD = Number(input * secondTokenExchangeRate)
      break
    case "mkr'":
      outputUSD = Number(input * secondTokenExchangeRate)
      break
    case "comp":
      outputUSD = Number(input * secondTokenExchangeRate)
      break
    default:
      outputUSD = ""  
  }
  
  return { inputUSD, outputUSD }
}

export function getToken(tokenId) {
  switch(tokenId) {
    case "ethToken":
      return ethToken
    case "daiToken":
      return daiToken
    case "usdtToken":
      return usdtToken
    case "rethToken":
      return rethToken
    case "usdcToken":
      return usdcToken
    case "wstethToken":
      return wstethToken
    case "usdsToken":
      return usdsToken
    case "uniToken":
      return uniToken
    case "wbtcToken":
      return wbtcToken
    case "wethToken":
      return wethToken
    case "lidoToken":
      return lidoToken
    case "linkToken":
      return linkToken
    case "mkrToken":
      return mkrToken
    case "compToken":
      return compToken
    case "arbToken":
      return arbToken
    case "weethToken":
      return weethToken
    case "usdeToken":
      return usdeToken
    case "cbbtcToken":
      return cbbtcToken
    default:
      return null
  }
}